// extracted by mini-css-extract-plugin
export default {"logoutPageTextContainer":"LogoutPage_logoutPageTextContainer__Hgrb5"};